import React, {memo, useEffect} from "react";
import {useDispatch} from "react-redux";
import {cardsActions} from "../cards.slice";

interface Props {
    cardId: string | undefined;
}

export const CardDownloader: React.FC<Props> = memo(props => {
    const dispatch = useDispatch();
    useEffect(() => {
        if (props.cardId !== undefined)
            dispatch(cardsActions.loadCard(props.cardId));
    }, [dispatch, props.cardId]);

    return null;
});